import { Dialog } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { sleep } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import StepFour from "./stepFour";
import StepOne from "./stepOne";
import StepThree from "./stepThree";
import StepTwo from "./stepTwo";

const ProfileUpdation = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [profile, setProfile] = useState([]);

  const logoutClick = () => {
    Dialog.confirm({
      content: "Do you want to logout?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        await sleep(2000);
        context.logout();

        context.setStorage("update_stu_data", "");
        /*context.setStorage("setp_one", "");
        context.setStorage("setp_two", "");
        context.setStorage("setp_three", "");*/
        context.setStorage("update_stu_profile", "no");
      },
    });
  };

  const isLogged = () => context.getStorage("update_stu_profile");

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = () => {
    context.setLoader(true);
    setProfile([]);
    const form = new FormData();
    form.append("uuid", studentData("uuid"));
    form.append("registerno", studentData("registerno"));
    axios.post(ServiceUrl.STUDENTS.GET_PROFILE, form).then((res) => {
      if (res["data"].status == "1") {
        setProfile(res["data"].data);
      }
      context.setLoader(false);
    });
  };

  const studentData = (fieldName) => {
    let d = context.getStorage("update_stu_data");
    if (d) d = JSON.parse(d);
    return d?.[fieldName];
  };

  if (isLogged() != "yes") {
    //history.push("/app");
    return <Navigate to="/" replace={true} />;
    return null;
  }
  return (
    <>
      <Header
        title="Profile Updation"
        backAction={[]}
        rightActions={
          <li>
            <i
              className="fa-solid fa-arrow-right-from-bracket fs-6"
              onClick={(e) => logoutClick()}
            ></i>
          </li>
        }
        noBack={true}
      />

      <div className="container-sm py-md-3 ">
        {profile && profile.id && (
          <div className="">
            {context.getStorage("setp_one") != "yes" && (
              <StepOne dataSource={profile} onSuccess={(e) => loadProfile()} />
            )}
            {context.getStorage("setp_one") == "yes" &&
              context.getStorage("setp_two") != "yes" && (
                <StepTwo
                  dataSource={profile}
                  onSuccess={(e) => loadProfile()}
                />
              )}
            {context.getStorage("setp_one") == "yes" &&
              context.getStorage("setp_two") == "yes" &&
              context.getStorage("setp_three") != "yes" && (
                <StepThree
                  dataSource={profile}
                  onSuccess={(e) => loadProfile()}
                />
              )}
            {context.getStorage("setp_one") == "yes" &&
              context.getStorage("setp_two") == "yes" &&
              context.getStorage("setp_three") == "yes" &&
              context.getStorage("setp_four") != "yes" && (
                <StepFour
                  dataSource={profile}
                  onSuccess={(e) => loadProfile()}
                />
              )}
          </div>
        )}
      </div>
    </>
  );
};
export default ProfileUpdation;
